import axios from 'axios';
import qs from 'qs';
import { Media } from '../interfaces/media';

const { REACT_APP_API_URL } = process.env;

export enum NamedDocumentKey {
  TRANSPARENCY_OBLIGATIONS_FULFILMENT = 'TRANSPARENCY_OBLIGATIONS_FULFILMENT',
}

interface DocumentV2 {
  title: string;
  url?: string | null;
  sectionName: string;
  media?: {
    data?: Media | null;
  } | null;
}

interface DocumentV2Item {
  id: number;
  attributes: DocumentV2;
}

interface DocumentsV2Response {
  data: DocumentV2Item[];
}

const getMediaUrl = (url?: string | null) => {
  if (!url) return undefined;
  if (url.startsWith('http')) return url;
  return `${REACT_APP_API_URL?.replace('/api', '')}${url}`;
};

export const getNamedDocumentHref = async (key: NamedDocumentKey) => {
  const query = qs.stringify(
    {
      filters: {
        websiteSection: {
          $eq: 'NAMED_DOCUMENT',
        },
        sectionName: {
          $eq: key,
        },
      },
      populate: '*',
      pagination: {
        pageSize: 2,
      },
    },
    { encodeValuesOnly: true }
  );

  const { data } = await axios.get<DocumentsV2Response>(
    `${REACT_APP_API_URL}/documents-v2?${query}`
  );

  if (data.data.length > 1) {
    console.error(`Duplicate named document bucket: ${key}`);
  }

  const document = data.data[0];
  return (
    document?.attributes.url ||
    getMediaUrl(document?.attributes.media?.data?.attributes.url)
  );
};
